import * as R from 'ramda'
import { Categories } from '../actions'

const DEFAULT_STATE = {
  categories: [],
  products: [],
}

const reducer = (state = DEFAULT_STATE, action) =>
  R.cond([
    [
      R.equals(Categories.TYPE.get_categories),
      () => {
        const children = R.filter(item => item.parent !== 0)(action.payload)
        let parents = R.filter(item => item.parent === 0)(action.payload)

        const parents_with_children = R.map(item => {
          const my_children = R.filter(child => child.parent === item.cat_ID)(
            children
          )
          return R.merge(item, { children: my_children })
        })(parents)
        return R.merge(state, { categories: parents_with_children })
      },
    ],
    [
      R.equals(Categories.TYPE.get_products),
      () => R.merge(state, { products_in_category: action.payload }),
    ],
    [R.T, R.always(state)],
  ])(action.type)

export default reducer
